<template>
  <filtertron-tray-section
    v-if="category.createdAt"
    id="category-configurator-delivery"
    :title="lang.get('category.configuration.delivery.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="checkbox styled">
        <input
          id="packingSlip"
          name="packingSlip"
          type="checkbox"
          :checked="category.packingSlip"
          @change="e => handleInput('packingSlip', e.target.checked)"
        />
        <label for="packingSlip">
          {{ lang.get('category.form.packing_slip.label') }}
        </label>
      </div>
      <div v-if="category.packingSlip" class="form-group">
        <label>
          {{ lang.get('category.form.packing_slip_instructions.label') }}
        </label>
        <merge-fields
          :merge-fields="categoryMergeFields"
          :help-text="lang.get('category.form.packing_slip_instructions.help')"
        >
          <multilingual
            :supported-languages="supportedLanguages"
            :resource="category"
            property="packingSlipInstructions"
            mode="markdown"
            @input="
              translated =>
                handleTranslatedInput(
                  'packingSlipInstructions',
                  translated,
                  true,
                  false
                )
            "
          />
        </merge-fields>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import Multilingual from '@/lib/components/Translations/Multilingual';
import MergeFields from '@/lib/components/Shared/MergeFields';
import handleInputMixin from '../handle-input-mixin.js';
import handleTranslatedInputMixin from '../handle-translated-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    Multilingual,
    MergeFields
  },
  mixins: [handleInputMixin, handleTranslatedInputMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['categoryMergeFields'])
  }
};
</script>
